import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Shell for the COMPANY panel's Sleep section. Title, mode badge, sub-page
 * card, page dropdown and filter all come from CompanySectionLayout, shared
 * with Breathwork and Habit Tracker.
 */
const CompanySleepLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;
  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Tracker Dashboard',
      path: `/${slug}/sleep`,
      description: 'Duration, quality and bedtime patterns'
    },
    {
      label: 'Sounds Dashboard',
      path: `/${slug}/sleep/sounds`,
      description: 'What your people listen to at night'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/sleep/users`,
      description: `Per-${population.replace(/s$/, '')} sleep records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Sleep"
      subtitle={`How your ${population} sleep, and what helps them do it.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanySleepLayout;
